<template>
  <div class="max-w-448 w-full mx-auto my-24">
    <div class="px-16 sm:px-0">
      <Breadcrumb to="/account/deactivation/questionnaire" header="Back" :routerLink="true" />
      <h1 class="text-h3 sm:text-h2 mt-24">Who did you end up hiring?</h1>
      <p class="text-body mt-16">Choose all that apply</p>
    </div>
    <form class="mt-16 px-16 sm:px-0" @submit.prevent="submitForm">
      <div
        :class="
          contactedMembers && contactedMembers.length > 3
            ? 'overflow-y-scroll bg-grey-background-contrast border-1 border-solid border-grey-divider-subdued h-386 p-24 rounded-xl'
            : ''
        "
      >
        <fieldset>
          <legend class="sr-only">Who did you end up hiring?</legend>
          <ul class="flex flex-col gap-16">
            <li v-for="(member, index) in contactedMembers" :key="index" class="flex items-center relative">
              <Card
                class="w-full flex items-center"
                :clickable="true"
                :aria-label="formatName(member.first_name, member.last_name)"
                role="checkbox"
                aria-checked="false"
                @click="handleMemberClick"
              >
                <Avatar
                  :imageUrl="member.cropped_photo_url"
                  size="medium"
                  class="mr-8"
                  :name="formatName(member.first_name, member.last_name)"
                  :photoStatus="member.profile_photo_status"
                />
                <p :id="`contacted-member-${index}`" class="text-body break-all pr-16">
                  {{ formatName(member.first_name, member.last_name) }}
                </p>
              </Card>
              <Checkbox
                :key="index"
                v-model="questionnaireData.matchedMembers"
                class="absolute right-8"
                labelName=""
                :ariaLabel="formatName(member.first_name, member.last_name)"
                :value="member.sso_uuid"
                :tabIndex="-1"
              />
            </li>
          </ul>
          <div class="flex items-center relative mt-16">
            <Card
              class="w-full flex items-center h-64"
              :clickable="true"
              aria-label="I do not see the person"
              role="checkbox"
              aria-checked="false"
              @click="handleNotDisplayedClick"
            >
              <p class="text-body">I do not see the person</p>
            </Card>
            <Checkbox
              v-model="questionnaireData.matchedMemberNotDisplayed"
              class="ml-auto absolute right-8"
              labelName=""
              ariaLabel="I do not see the person"
              value="matched_member_not_displayed"
              :tabIndex="-1"
            />
          </div>
        </fieldset>
      </div>
      <div
        class="absolute bottom-0 left-0 px-16 w-full border-t-1 border-solid border-grey-divider-subdued bg-foreground sm:static sm:px-0 sm:border-none"
      >
        <Button value="Next" variant="primary" size="medium" type="submit" class="w-full my-16 sm:mt-32" />
      </div>
    </form>
  </div>
</template>
<script lang="ts">
import Breadcrumb from '../../../components/breadcrumb/Breadcrumb.vue';
import Card from '../../../components/card/Card.vue';
import Avatar from '../../../components/avatar/Avatar.vue';
import Checkbox from '../../../components/checkbox/Checkbox.vue';
import Button from '../../../components/button/Button.vue';
import CloseTheLoop from '@/lib/public_api/CloseTheLoop';

export default {
  name: 'SitterSelect',
  components: { Breadcrumb, Card, Avatar, Checkbox, Button },
  props: {
    ctlData: {
      type: CloseTheLoop,
      default: null,
    },
  },
  data(): any {
    return {
      questionnaireData: {
        matchSuccessful: true,
        matchedMemberNotDisplayed: false,
        matchedMembers: [],
      },
    };
  },
  computed: {
    contactedMembers(): string[] {
      return this.ctlData?.contactedMembers;
    },
  },
  methods: {
    formatName(first: string, last: string) {
      return `${first} ${last[0]}.`;
    },
    handleMemberClick(e) {
      const { value } = e.currentTarget.nextSibling.querySelector('input');
      const members = this.questionnaireData.matchedMembers;
      if (members.includes(value)) {
        this.questionnaireData.matchedMembers = members.filter((id) => id !== value);
        e.currentTarget.setAttribute('aria-checked', false);
      } else {
        this.questionnaireData.matchedMembers.push(value);
        e.currentTarget.setAttribute('aria-checked', true);
      }
    },
    handleNotDisplayedClick(e) {
      const notDisplayed = this.questionnaireData.matchedMemberNotDisplayed;
      if (notDisplayed) {
        this.questionnaireData.matchedMemberNotDisplayed = false;
        e.currentTarget.setAttribute('aria-checked', false);
      } else {
        this.questionnaireData.matchedMemberNotDisplayed = true;
        e.currentTarget.setAttribute('aria-checked', true);
      }
    },
    async submitForm() {
      sessionStorage.setItem('show_confirmation_page', 'true');
      await this.$emit('updateQuestionnaire', this.questionnaireData);
      await this.$emit('closeAccount');
    },
  },
};
</script>
